export enum MeasurementUnit {
    SquareMeter = 'm²',
    Meter = 'm',
    KiloWatt = 'kW'
}
